/**
 * Created by andrey on 08.08.2025
 */

cc.ScaleBy = function (duration, sx, sy) {
    cc.ScaleTo.prototype.constructor.call(this, duration, sx, sy);
};

cc.ScaleBy.prototype = Object.assign(Object.create(cc.ScaleTo.prototype), {
    constructor: cc.ScaleBy,

    startWithTarget: function (target) {
        cc.ScaleTo.prototype.startWithTarget.call(this, target);

        this._deltaX = this._startScaleX * this._endScaleX - this._startScaleX;
        this._deltaY = this._startScaleY * this._endScaleY - this._startScaleY;
    }
});

cc.scaleBy = (duration, sx, sy) => new cc.ScaleBy(duration, sx, sy);
